'use client'

import { Button } from '@/core/ui/atoms/button'
import { FormInput } from '@/core/ui/forms/input'
import { useTranslations } from 'next-intl'
import { useUpdatePassword } from './use-update-password'

type Props = {
  onSuccess: () => void
}

export function UpdatePassword(props: Props) {
  const t = useTranslations()

  const { form, handleSubmit, isPending } = useUpdatePassword(props)

  return (
    <form className='flex flex-col gap-4 p-4' onSubmit={handleSubmit}>
      <p className='text-center text-2xl font-semibold'>
        {t('profile.updatePassword')}
      </p>
      <FormInput
        name='current_password'
        label={t('forms.currentPasswordLabel')}
        labelClassName='text-mountain-bluebird'
        control={form.control}
        type='password'
      />
      <FormInput
        name='new_password'
        label={t('forms.newPasswordLabel')}
        control={form.control}
        labelClassName='text-mountain-bluebird'
        type='password'
      />
      <FormInput
        name='new_password_confirmation'
        label={t('forms.passwordConfirmationLabel')}
        control={form.control}
        labelClassName='text-mountain-bluebird'
        type='password'
      />
      <Button loading={isPending} className='mt-1 h-12 w-full cursor-pointer'>
        {t('actions.saveChanges')}
      </Button>
    </form>
  )
}
